import React, { useState } from 'react';
import './index.css';
import useAllGamesPage from '../../../../hooks/useAllGamesPage';
import GameCard from './gameCard';

/**
 * Component to display the "All Games" page, which provides functionality to view, create, and join games.
 * @returns A React component that includes:
 * - A "Create Game" button to open a modal for selecting a game type.
 * - A list of available games, each rendered using the `GameCard` component.
 * - A refresh button to reload the list of available games from the server.
 */
const AllGamesPage = () => {
  const [isPublic, setIsPrivate] = useState(true);
  const [joinCode, setJoinCode] = useState('');

  const {
    availableGames,
    handleJoin,
    fetchGames,
    isModalOpen,
    handleToggleModal,
    handleSelectGameType,
    error,
  } = useAllGamesPage();

  return (
    <div className='game-page'>
      {/* Modal Backdrop and Content */}
      {isModalOpen && (
        <>
          <div className='modal-backdrop active' onClick={handleToggleModal} />
          <div className='game-modal active'>
            <div className='modal-content'>
              <h2>Create or Join a Game</h2>
              <button className='btn-close' onClick={handleToggleModal}>
                Close
              </button>

              {/* Create Game */}
              <div className='game-type-buttons'>
                <label>
                  <input
                    type='checkbox'
                    checked={!isPublic}
                    onChange={() => setIsPrivate(!isPublic)}
                  />
                  Private Game
                </label>
                <button
                  className='btn-select-game'
                  onClick={() => {
                    handleSelectGameType('Nim', isPublic);
                  }}>
                  Nim
                </button>
                <button
                  className='btn-select-game'
                  onClick={() => handleSelectGameType('BattleShip', isPublic)}>
                  Battleship
                </button>
              </div>

              {/* Join Private Game */}
              <div className='join-game-section'>
                <input
                  type='text'
                  placeholder='Enter game code to join'
                  value={joinCode}
                  onChange={e => setJoinCode(e.target.value)}
                />
                <button className='btn-join-game-modal' onClick={() => handleJoin(joinCode)}>
                  Join Game
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Available Games List */}
      <div className='game-available'>
        <div className='game-list'>
          {error && <div className='game-error'>{error}</div>}
          <h1>Available Games</h1>
          <button className='btn-refresh-list' onClick={fetchGames}>
            Refresh List
          </button>
          <button className='btn-create-game' onClick={handleToggleModal}>
            Create or Join Game
          </button>
          <div className='game-items'>
            {availableGames.map(game => (
              <GameCard key={game.gameID} game={game} handleJoin={handleJoin} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllGamesPage;
